export const TRANSACTION_TYPES = {
  a2c: {
    id: "a2c",
    name: "transaction-types.a2c",
  },
  c2a: {
    id: "c2a",
    name: "transaction-types.c2a",
  },
  ecom: {
    id: "ecom",
    name: "transaction-types.ecom",
  },
  refund: {
    id: 6005,
    name: "transaction-types.refund",
  },
  preauth: {
    id: "preauth",
    name: "transaction-types.preauth",
  },
  postauth: {
    id: "postauth",
    name: "transaction-types.postauth",
  },
  autodebit: {
    id: "autodebit",
    name: "transaction-types.autodebit",
  },
  p2p: {
    id: "p2p",
    name: "transaction-types.p2p",
  },
  6004: {
    id: 6004,
    name: "transaction-types.6004",
  },
  6003: {
    id: 6003,
    name: "transaction-types.6003",
  },
};
